import { Button, Box, Container, styled, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useMemo } from "react";
import { HoverLayer } from "../components/HoverAnimation";
import Section from "../components/Section";
import arrowV from "../images/arrow-vertical.png";
import arrow from "../images/arrow.png";
import bottomPolygonBg from "../images/bg-polygon-1.png";
import topPolygonBg from "../images/bg-polygon-2.png";
import shadow from "../images/drop-shadow.png";
import img2 from "../images/Dynamic-Data-Layer.png";
import bg01 from "../images/gen2bg.png";
import interpo from "../images/interpo.png";
import img4 from "../images/IPFS.png";
import img1 from "../images/NFT-Administration.png";
import img3 from "../images/NFT.png";
import aboutImage from "../images/nftabout.png";
import oracle from "../images/oracle.png";
import protocolgen2 from "../images/protocolgen2.png";
import whiteadmin from "../images/white_admin.png";
import whitedatalayer from "../images/white_datalayer.png";
import whitenft from "../images/white_nft.png";

export const HowItWork = ({ white = false }) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Section
      sx={{ pt: 0 }}
      style={{
        width: "100%",
        position: "relative",
        padding: sm ? "0 30px" : "0px 0px"
      }}
    >
      <Typography
        variant="h3"
        align="center"
        mb={10}
        color={white ? "#FFFFFF" : null}
      >
        How it works?
      </Typography>
      <Box
        sx={{ width: "100%", position: "relative", mx: "auto" }}
        display="grid"
        gridTemplateColumns={sm ? "1fr 1fr" : "1fr 1fr 1fr"}
        columnGap={10}
        maxWidth="lg"
      >
        {!sm && (
          <div>
            <HoverLayer
              pt="15%"
              title="The admin prepares the NFT collection/ id with the use case and submits to the Dynamic Data Layer"
            >
              <img
                src={white ? whiteadmin : img1}
                alt=""
                className="d-block"
                width="100%"
              />
            </HoverLayer>
          </div>
        )}

        <div>
          {sm && (
            <div>
              <HoverLayer
                pt={1}
                title="The admin prepares the NFT collection/ id with the use case and submits to the Dynamic Data Layer"
                left={true}
              >
                <img
                  src={white ? whiteadmin : img1}
                  alt=""
                  className="d-block"
                  width="100%"
                />
              </HoverLayer>
            </div>
          )}
          <Box className="p-relative" mb="100px" mt={sm ? "100px" : "0px"}>
            <HoverLayer
              left={sm ? true : false}
              title="The Dynamic Data Layer merged the original metadata of the registered NFT with the use case submitted by the NFT admin"
            >
              <img
                src={white ? whitedatalayer : img2}
                alt=""
                className="d-block"
                width="100%"
              />
            </HoverLayer>

            {!sm && (
              <Arrow
                title="Register NFT"
                position="left"
                sx={{
                  position: "absolute",
                  bottom: "16px",
                  right: "calc(100% - 32px)"
                }}
              />
            )}
            <Arrow
              title="Send metadata to registered NFT"
              position="right"
              sx={{
                position: "absolute",
                bottom: "-4px",
                left: "calc(100% - 32px)"
              }}
              spaceBottom={sm ? true : false}
            />
            <Arrow
              title="Retrieved original metadata"
              vertical
              position="bottom"
              sx={{
                position: "absolute",
                top: "100%",
                left: "calc(50% - 8px)"
              }}
            />
            {sm && (
              <Arrow
                title="Register NFT"
                vertical
                position="bottom"
                sx={{
                  position: "absolute",
                  bottom: "100%",
                  left: "calc(50% - 8px)",

                  span: {
                    mb: 0
                  }
                }}
              />
            )}
          </Box>

          <div>
            <img src={img4} alt="" className="d-block mx-auto" width="60%" />
          </div>
        </div>

        <NFTDiv>
          <HoverLayer
            right={sm ? true : false}
            title="Dynamic Metadata is embedded on the NFT (e.g.) through a point system, attributes merged, transform NFT, which can be checked in real-time."
          >
            <img
              src={white ? whitenft : img3}
              alt=""
              className="d-block"
              width="100%"
            />
          </HoverLayer>
        </NFTDiv>
      </Box>
    </Section>
  );
};

const Arrow = ({ title, vertical = false, spaceBottom = false, ...props }) => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      display="flex"
      flexDirection={vertical ? "row" : "column"}
      justifyContent="center"
      alignItems="center"
      {...props}
    >
      <img
        src={vertical ? arrowV : arrow}
        alt=""
        className="d-block"
        width={vertical ? undefined : "140px"}
        height={vertical ? "140px" : undefined}
        style={{ zIndex: 10, maxWidth: "initial" }}
      />

      <Typography
        variant="caption"
        align={vertical ? "left" : "center"}
        sx={{
          color: "#3576FF",
          fontWeight: "normal",
          pl: vertical ? 1 : 0,
          mb: vertical ? 4 : 0
        }}
        style={
          sm
            ? {
                textAlign: "center",
                position: "absolute",
                background: "black",
                zIndex: 16,
                width: "130px",
                marginBottom: spaceBottom ? "148px" : ""
              }
            : {}
        }
      >
        {title}
      </Typography>
    </Box>
  );
};

const NFTPageStyle = styled(Box)`
  overflow-x: auto;

  > .MuiBox-root {
    &:nth-of-type(01) {
      background-image: url(${bg01});
      color: white;
      min-height: 100vh;
    }
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

const FulllWidthImage = styled("img")`
  width: 100%;
`;

const UsageTitle = styled(Typography)`
  font-weight: 700;
  color: #4d4d4d;
`;

const UsageDetail = styled(Typography)`
  font-weight: 400;
  color: #4d4d4d;
`;

const CenteredDetail = styled(UsageDetail)`
  text-align: center;
`;

const Weight400Typo = styled("span")`
  font-weight: 400;
  color: #4d4d4d;
`;

const UsageBox = ({ title, detail }) => (
  <Box
    elevation={0}
    className="d-flex flex-column"
    sx={{
      width: {
        xs: "100%",
        md: "50%"
      },
      padding: "2rem 1.5rem"
    }}
  >
    <UsageTitle>{title}</UsageTitle>
    <UsageDetail>{detail}</UsageDetail>
  </Box>
);

const MarginBottomBox = styled(Box)`
  margin-bottom: 48px;
`;

const SectionWithoutLastMargin = styled(Section)`
  background: linear-gradient(#ffffff, #f9f9f9);

  > div > * {
    &:last-child {
      margin-bottom: 0px !important;
    }
  }
`;

const NFTDiv = styled("div")`
  margin-top: 0px;
  @media (max-width: 600px) {
    margin-top: 300px;
  }
  @media (max-width: 490px) {
    margin-top: 280px;
  }
  @media (max-width: 435px) {
    margin-top: 255px;
  }
  @media (max-width: 400px) {
    margin-top: 230px;
  }
`;

export const FullWidthService = ({
  title,
  detail,
  img,
  left = true,
  imageCol = 4,
  imageHeight = 180,
  color = "#4D4D4D"
}) => {
  const right = useMemo(() => !left, [left]);
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const boxCol = 12 - imageCol;

  return (
    <MarginBottomBox className="d-flex flex-wrap">
      {md && left && (
        <Box className={md ? `col-${imageCol} flex-shrink` : "col-12 pb-4"}>
          <img
            src={img}
            alt={title}
            className="d-block mx-auto"
            height={imageHeight}
          />
        </Box>
      )}
      <Box className={md ? `col-${boxCol}` : "col-12"}>
        <Typography variant="h3" className="mb-9" color={color}>
          {title}
        </Typography>
        <Typography
          variant="body2"
          className={!md ? "mb-4" : ""}
          sx={{ opacity: "0.7" }}
          color={color}
        >
          {detail}
        </Typography>
        {!md && (
          <img src={img} alt={title} className="d-block mx-auto" height={160} />
        )}
      </Box>
      {md && right && (
        <Box className={md ? `col-${imageCol} flex-shrink` : "col-12 pb-4"}>
          <img
            src={img}
            alt={title}
            className="d-block mx-auto"
            height={imageHeight}
          />
        </Box>
      )}
    </MarginBottomBox>
  );
};

const NFTgen2Page = () => {
  const theme = useTheme();
  // const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));

  const whatis = useMemo(() => {
    return [
      {
        title: "",
        detail:
          "With the ‘Dynamic Data Layer, NFT Gen2 allows tracking and tracing of any NFT usage on business requirements & matches NFT utilities with any business needs in the real world.  ",
        img: protocolgen2,
        imageCol: 5,
        imageHeight: 210
      }
    ];
  }, []);
  const services = useMemo(() => {
    return [
      {
        title: "Interoperability",
        detail: [
          "No matter which blockchain network your NFTs are based in, SIX Protocol's NFT Gen 2 can be applied to any existing collection.",
          <br />,
          <br />,
          "Since the original Metadata of an NFT can merge with the Dynamic Metadata on SIX Protocol, which will be embedded on the NFT for users' utility access and usage"
        ],
        img: interpo,
        left: false
      },
      {
        title: "Oracle",
        detail:
          "When signing messages from other blockchain networks to merge Dynamic Metadata to the Dynamic Data Layer, NFT Gen 2 will utilize oracle to verify the ownership of the original message to ensure the proof of ownership and prevent fraud.",
        img: oracle
      }
    ];
  }, []);

  const usages = useMemo(() => {
    return [
      {
        title: "Mark Usage Value",
        detail:
          "The business can embed the use case and redeemable inventory for the users to obtain their rights."
      },
      {
        title: "Point System",
        detail:
          "Dynamic Metadata allows the NFT to collect the point and work as a membership or CRM tool for the users and brand."
      },
      {
        title: "Proof of Attendance",
        detail:
          "Users can use the NFT as a Proof of Attendance concept as a fraud-free ticket to attend the events or complete the quest and journey."
      },
      {
        title: "Merge Attribute",
        detail:
          "Once the users have completed their task or quest, the attribute of NFT can be merged with new attributes."
      },
      {
        title: "Transform NFT",
        detail:
          "Dynamic Metadata allows the collection owner to change the artwork on NFT. The business can create a business case related to artwork transformation and its attributes to create uniqueness as a symbol of use."
      },
      {
        title: "Delegate Gas Fee",
        detail:
          "Via fee delegation address, users can process any NFT transaction without having to prepare for a gas fee which will be provided by either the business or the collection owner."
      }
    ];
  }, []);

  return (
    <NFTPageStyle>
      <Section className="d-flex flex-column justify-center align-center">
        <Box maxWidth="md" className="mx-auto">
          <Typography
            variant="h3"
            align="center"
            color="#8B8B8B"
            className="mb-4"
            sx={{ marginTop: "240px" }}
          >
            ‘Beyond NFT Technology’
          </Typography>
          <CenteredDetail>
            NFT Gen2 is a dynamic data layer that runs on SIX Protocol to unlock
          </CenteredDetail>
          <CenteredDetail>
            the potential of NFT integration with various business models.
          </CenteredDetail>
        </Box>
      </Section>

      <Box
        sx={{
          backgroundColor: "white",
          backgroundImage: `url(${topPolygonBg})`,
          backgroundSize: "contain !important",
          backgroundPosition: "0 -20% !important",
          position: "relative",

          "&:after": {
            content: '""',
            width: "100%",
            height: "40px",
            position: "absolute",
            bottom: "-40px",
            left: 0,
            backgroundImage: `url(${shadow})`,
            backgroundPosition: "center"
          }
        }}
      >
        <Section>
          <Typography
            variant="h3"
            className="mb-9"
            align="center"
            color="#4D4D4D"
          >
            What is <Weight400Typo>‘NFT Gen2’</Weight400Typo> ?
          </Typography>
          {whatis.map((s) => (
            <FullWidthService
              title={s.title}
              detail={s.detail}
              img={s.img}
              imageCol={s.imageCol}
              imageHeight={s.imageHeight}
            />
          ))}
          <Typography
            variant="h3"
            align="center"
            color="#4D4D4D"
            className="mb-4"
          >
            ‘Dynamic Data Layer’
          </Typography>
          <UsageDetail>
            The Dynamic Data Layer is responsible for storing and exchanging
            Dynamic Metadata of specific NFTs, along with the unique
            characteristics of the chain’s binary, which enable businesses to
            engrave the usage such as ticketing, coupon, campaign, and other
            marketing data on individual NFT.
          </UsageDetail>
        </Section>
        <HowItWork />
      </Box>

      <SectionWithoutLastMargin>
        {services.map((s) => (
          <FullWidthService
            title={s.title}
            detail={s.detail}
            img={s.img}
            left={s.left}
          />
        ))}
      </SectionWithoutLastMargin>

      <Section
        sx={{
          pt: 0,
          backgroundImage: `url(${bottomPolygonBg})`,
          backgroundPosition: "right bottom !important"
        }}
      >
        <Typography
          variant="h3"
          className="mb-9"
          align="center"
          color="#4D4D4D"
        >
          Unique Use of Dynamic Metadata
        </Typography>
        <Box className="d-flex flex-wrap mx-n-3">
          {usages.map((u) => (
            <UsageBox title={u.title} detail={u.detail} />
          ))}
        </Box>
      </Section>

      <Container maxWidth="xl">
        <FulllWidthImage src={aboutImage} alt="About NFT Gen 2" />
        <Button
          variant="contained"
          size="small"
          className={`d-block mx-auto mb-10 pt-0 pb-0 px-6`}
          href="https://whalegate.sixprotocol.com/nfts"
          sx={{
            marginTop: md ? "-80px" : "0px",
            width: "max-content",
            lineHeight: "36px",
            background: "linear-gradient(90deg, #41D1F6 0%, #343DE7 100%)"
          }}
        >
          EXPLORE NOW
        </Button>
      </Container>

      <Box
        sx={{
          background:
            "linear-gradient(89.85deg, #04B1FB 2.64%, #402FF2 103.58%)",
          height: "56px"
        }}
      />
    </NFTPageStyle>
  );
};

export default NFTgen2Page;
